// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import cmeetingEntity from './entities/cmeeting.json';
import cmeetingMenu from '../pages/cmeeting/menu.json';
import cmeetingFullForm from '../pages/cmeeting/forms/full.json';
import cmeetingContextForm from '../pages/cmeeting/forms/context.json';
import cmeetingMiniForm from '../pages/cmeeting/forms/mini.json';
import cmeetingLookupForm from '../pages/cmeeting/forms/lookup.json';
import cmeetingTableView from '../pages/cmeeting/views/table.json';
import cmeetingStagesView from '../pages/cmeeting/views/stages.json';
import cmeetingCardsView from '../pages/cmeeting/views/cards.json';
import cmeetingSplitView from '../pages/cmeeting/views/split.json';
import cmeetingCalendarView from '../pages/cmeeting/views/calendar.json';
import cmeetingDashboardView from '../pages/cmeeting/views/dashboard.json';

/** Тип запису «Зустріч» зі сторінками пакета: меню, форми та подання з pages/cmeeting/. */
export const cmeetingDefinition: IRecordTypeDefinition = {
  ...cmeetingEntity,
  views: assembleViewSet({
      table: cmeetingTableView,
      stages: cmeetingStagesView,
      cards: cmeetingCardsView,
      split: cmeetingSplitView,
      calendar: cmeetingCalendarView,
      dashboard: cmeetingDashboardView,
  }),
  form: cmeetingFullForm,
  forms: { full: cmeetingFullForm, context: cmeetingContextForm, mini: cmeetingMiniForm, lookup: cmeetingLookupForm },
  menu: cmeetingMenu,
} as IRecordTypeDefinition;
